<template>
<div class="step step--type-4">
<div class="step__main" :class="agencyMode ? 'step__main--agency-mode' : ''">
<h2 class="heading-step">
<span class="heading-step__step">試算結果 </span>
<span class="heading-step__title">あなたをささえる公的保障はこちらです</span>
<!-- /.heading-step --></h2>

<div class="toggle toggle--type-01">
<div class="toggle__head">
<h3 class="toggle__head-heading">老後を迎えたら</h3>
<p class="toggle__head-sum"><span class="toggle__head-sum-label">老齢年金　年額</span> <span class="toggle__head-sum-price">{{roureiNenkinTotalString}}</span><span class="toggle__head-sum-unit">円</span></p>
<!-- /.toggle__head --></div>
<transition
  @enter="showItem"
  @after-enter="printAfterEnter"
  @leave="hideItem"
  @after-leave="printAfterLeave"
  v-bind:css="false"
>
<div class="toggle__content" id="show01" v-show="show01">
<h4 class="toggle__content-heading">老齢厚生年金</h4>

<div class="box-underline">
<p class="detailed-result detailed-result--type-01">
<span class="detailed-result__formula">
<span class="detailed-result__group detailed-result__group--groupe-01" v-show="value1 < 50">
<span class="detailed-result__formula-desc">これまでの加入実績に<br>応じた年金額</span>
<span class="detailed-result__formula-value">{{roureiKouseiNenkinString}}</span>
<span class="detailed-result__formula-unit">円</span>
<span class="detailed-result__formula-operator" v-show="value3 === '会社員・公務員'">＋</span>
<span class="detailed-result__formula-brackets" v-show="value3 === '会社員・公務員'">(</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-02" v-show="value1 < 50 && value3 === '会社員・公務員'">
<span class="detailed-result__formula-desc"><span class="detailed-result__formula-desc-inner">現在から退職までの平均見込年収<sup>*1</sup>（賞与含む）</span></span>
<span class="detailed-result__formula-value">{{heikinMikomiNenshuString}}</span>
<span class="detailed-result__formula-unit">円</span>
<span class="detailed-result__formula-operator">×</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-03" v-show="(value1 < 50 && value3 === '会社員・公務員') || 50 <= value1">
<span class="detailed-result__formula-constant" v-show="value1 < 50 && value3 === '会社員・公務員'">5.481</span>
<span class="detailed-result__formula-operator" v-show="value1 < 50 && value3 === '会社員・公務員'">÷</span>
<span class="detailed-result__formula-constant" v-show="value1 < 50 && value3 === '会社員・公務員'">1000</span>
<span class="detailed-result__formula-operator" v-show="value1 < 50 && value3 === '会社員・公務員'">×</span>
<span class="detailed-result__formula-value" v-show="50 <= value1">{{roureiNenkinTotalString}}</span>
<span class="detailed-result__formula-unit" v-show="50 <= value1">円</span>
<span class="detailed-result__formula-operator" v-show="50 <= value1">－</span>
<span class="detailed-result__formula-value" v-show="50 <= value1">{{roureiKisoNenkinString}}</span>
<span class="detailed-result__formula-unit" v-show="50 <= value1">円</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-04">
<span class="detailed-result__formula-desc" v-show="value1 < 50 && value3 === '会社員・公務員'">現在から退職までの<br>予定勤務年数</span>
<span class="detailed-result__formula-value" v-show="value1 < 50 && value3 === '会社員・公務員'">{{yoteiKinzokuNensu}}</span>
<span class="detailed-result__formula-unit" v-show="value1 < 50 && value3 === '会社員・公務員'">年</span>
<span class="detailed-result__formula-brackets" v-show="value1 < 50 && value3 === '会社員・公務員'">)</span>
<span class="detailed-result__formula-operator">＝</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__formula --></span>

<span class="detailed-result__answer">
<span class="detailed-result__group">
<span class="detailed-result__formula-value"><span class="detailed-result__formula-value-index">① </span>{{roureiKouseiNenkinTotalString}}</span>
<span class="detailed-result__formula-unit">円</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>
<!-- /.box-underline --></div>

<h4 class="toggle__content-heading">老齢基礎年金</h4>

<div class="box-underline">
<p class="detailed-result detailed-result--type-02">
<span class="detailed-result__formula">
<span class="detailed-result__group detailed-result__group--groupe-01">
<span class="detailed-result__formula-desc" v-show="value1 < 50">これまでの加入実績に<br>応じた年金額</span>
<span class="detailed-result__formula-value" v-show="value1 < 50">{{koremadenoKanyuuJissekiNiOujitaNenkinGakuString}}</span>
<span class="detailed-result__formula-unit" v-show="value1 < 50">円</span>
<span class="detailed-result__formula-operator" v-show="value1 < 50">＋</span>
<span class="detailed-result__formula-value" v-show="50 <= value1">{{roureiKisoNenkinString}}</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-02" v-show="value1 < 50">
<span class="detailed-result__formula-constant">779,300</span>
<span class="detailed-result__formula-unit">円</span>
<span class="detailed-result__formula-operator">×</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-03" v-show="value1 < 50">
<span class="detailed-result__formula-desc">現在から<br>60歳までの年数</span>
<span class="detailed-result__formula-value">{{genzaiKara60SaiMadenoNensu}}</span>
<span class="detailed-result__formula-unit">年</span>
<span class="detailed-result__formula-operator">÷</span>
<span class="detailed-result__formula-constant">40</span>
<span class="detailed-result__formula-operator">＝</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__formula --></span>

<span class="detailed-result__answer">
<span class="detailed-result__group">
<span class="detailed-result__formula-value"><span class="detailed-result__formula-value-index">② </span>{{roureiKisoNenkinString}}</span>
<sup class="detailed-result__formula-sup" v-if="value1 < 50 && value3 === '会社員・公務員'">*2</sup>
<sup class="detailed-result__formula-sup" v-else>*1</sup>
<span class="detailed-result__formula-unit">円</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>
<!-- /.box-underline --></div>

<div class="toggle__content-total">
<p><span class="toggle__content-total-label">老齢年金（①＋②）年額</span><span class="toggle__content-total-price"><em class="toggle__content-total-price-num">{{roureiNenkinTotalString}}</em><span class="toggle__content-total-price-unit">円</span></span></p>
<!-- /.total-price --></div>

<ul class="list-notice">
<li class="list-notice__item" v-show="value1 < 50 && value3 === '会社員・公務員'"><small><span class="list-notice__item-mark">＊1 </span>年収の上限は以下の算式に基づき1,194万円とし、これに12分の1を乗じたものを平均標準報酬額とみなして算出しています。<br>標準報酬月額の最大62万円×12か月＋標準賞与額の最大150万円×3回＝1,194万円</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">＊<span v-if="value3 === '会社員・公務員'">2</span><span v-else>1</span> </span>老齢基礎年金は上限779,300円です。<br>上限を超える場合は779,300円となります。</small></li>
<!-- /.list-notice --></ul>

<ul class="list-notice" v-show="50 <= value1">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>厚生年金基金から支給される額（厚生年金基金の代行部分）は反映しておりません。</small></li>
<!-- /.list-notice --></ul>
<!-- /.toggle__content --></div>
</transition>

<div class="toggle__foot">
<button type="button" class="toggle__foot-button" @click="show01 = !show01"><span class="toggle__foot-button-inner" v-if="show01">計算の詳細を閉じる</span><span class="toggle__foot-button-inner" v-else><span class="toggle__foot-button-inner-open">計算の詳細を開く</span></span></button>
<!-- /.toggle__foot --></div>
<!-- /.toggle --></div>

<div class="toggle toggle--type-02">
<div class="toggle__head">
<h3 class="toggle__head-heading">病気になったら</h3>
<p class="toggle__head-sum"><span class="toggle__head-sum-text">※一定条件のもと窓口で支払った合計30万円のうち</span> <span class="toggle__head-sum-label">高額療養費 <span class="toggle__head-sum-label-sub">（払い戻される金額）</span></span> <span class="toggle__head-sum-price">{{kougakuRyouyouValueString}}<span class="toggle__head-sum-unit">円 </span></span> <strong class="toggle__head-sum-error-text" v-show="!value12Inputed && !(value3 === '自営業' || (value3 === '専業主婦・専業主夫' && value4 === '国保の加入者'))">※一部項目が未入力のため、試算できません。</strong></p>
<!-- /.toggle__head --></div>
<transition
  @enter="showItem"
  @after-enter="printAfterEnter"
  @leave="hideItem"
  @after-leave="printAfterLeave"
  v-bind:css="false"
>
<div class="toggle__content" id="show02" v-show="show02">
<div class="heading-tag">
<h4 class="heading-tag__heading">設定条件</h4>
<!-- /.heading-tag --></div>

<ul class="list-burette">
<li class="list-burette__item">70歳未満の健康保険加入者が入院</li>
<li class="list-burette__item">4月16日から5月15日まで30日間入院</li>
<li class="list-burette__item">2か月合計で100万円(50万円＋50万円)の医療費がかかり、窓口で合計30万円(15万円＋15万円)を支払った場合</li>
<!-- /.list-burette --></ul>

<h4 class="toggle__content-heading" v-show="typeof kougakuRyouyouValue === 'number' && isFinite(kougakuRyouyouValue)">高額療養費</h4>

<!-- ▼▼▼ 28万円以上53万円未満の場合表示 ▼▼▼ -->
<p class="detailed-result detailed-result--type-03" v-show="kougakuRyouyouValue === 135140">
<span class="detailed-result__formula">
<span class="detailed-result__group detailed-result__group--groupe-01">
<span class="detailed-result__formula-brackets">[</span>
<span class="detailed-result__formula-desc">窓口で支払った金額</span>
<span class="detailed-result__formula-constant">150,000円</span>
<span class="detailed-result__formula-operator">－</span>
<span class="detailed-result__formula-brackets">{</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-02">
<span class="detailed-result__formula-constant">80,100円</span>
<span class="detailed-result__formula-operator">＋</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-03">
<span class="detailed-result__formula-brackets">(</span>
<span class="detailed-result__formula-desc">医療費</span>
<span class="detailed-result__formula-constant">500,000円</span>
<span class="detailed-result__formula-operator">－</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-04">
<span class="detailed-result__formula-constant">267,000円</span>
<span class="detailed-result__formula-brackets">)</span>
<span class="detailed-result__formula-operator">×</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-05">
<span class="detailed-result__formula-constant">1％</span>
<span class="detailed-result__formula-brackets">}</span>
<span class="detailed-result__formula-brackets">]</span>
<span class="detailed-result__formula-operator">×</span>
<span class="detailed-result__formula-constant">2</span>
<span class="detailed-result__formula-operator">＝</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__formula --></span>

<span class="detailed-result__answer detailed-result__answer--type-02">
<span class="detailed-result__answer-inner">
<span class="detailed-result__answer-value">135,140</span>
<span class="detailed-result__answer-unit">円</span>
<!-- /.detailed-result__answer-inner --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>
<!-- ▲▲▲ 28万円以上53万円未満の場合表示 ▲▲▲ -->

<!-- ▼▼▼ 28万円未満の場合表示 ▼▼▼ -->
<p class="detailed-result detailed-result--type-07" v-show="kougakuRyouyouValue === 184800">
<span class="detailed-result__formula">
<span class="detailed-result__group detailed-result__group--groupe-01">
<span class="detailed-result__formula-brackets">(</span>
<span class="detailed-result__formula-desc">窓口で支払った金額</span>
<span class="detailed-result__formula-constant">150,000円</span>
<span class="detailed-result__formula-operator">－</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-02">
<span class="detailed-result__formula-constant">57,600円</span>
<span class="detailed-result__formula-brackets">)</span>
<span class="detailed-result__formula-operator">×</span>
<span class="detailed-result__formula-constant">2</span>
<span class="detailed-result__formula-operator">＝</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__formula --></span>

<span class="detailed-result__answer detailed-result__answer--type-02">
<span class="detailed-result__answer-inner">
<span class="detailed-result__answer-value">184,800</span>
<span class="detailed-result__answer-unit">円</span>
<!-- /.detailed-result__answer-inner --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>
<!-- ▲▲▲ 28万円未満の場合表示 ▲▲▲ -->

<!-- ▼▼▼ 53万円以上の場合表示 ▼▼▼ -->
<div v-show="kougakuRyouyouValue === 0">
<ul class="list-notice" v-if="!value12Inputed && !(value3 === '自営業' || (value3 === '専業主婦・専業主夫' && value4 === '国保の加入者'))">
<li class="list-notice__item text-important"><small><span class="list-notice__item-mark">※ </span>一部項目が未入力のため、試算できません。</small></li>
</ul>
<div v-else>
<p>月単位の医療費が以下の金額までの場合、3割負担となり払戻しはありません。</p>

<div class="column column--col-2">
<div class="column__inner">
<div class="column__col">
<table class="table">
<colgroup>
<col class="table__first-col">
<col>
<col>
</colgroup>
<tr>
<th rowspan="3">会社員</th>
<th>標準報酬月額</th>
<th>月単位の医療費</th>
</tr>
<tr>
<td>83万以上</td>
<td>842,000円</td>
</tr>
<tr>
<td>53万以上</td>
<td>558,000円</td>
</tr>
<!-- /.table --></table>
<!-- /.column__col --></div>

<div class="column__col">
<table class="table">
<colgroup>
<col class="table__first-col">
<col>
<col>
</colgroup>
<tr>
<th rowspan="3">自営業</th>
<th>世帯の所得<sup>*</sup></th>
<th>月単位の医療費</th>
</tr>
<tr>
<td>901万円超</td>
<td>842,000円</td>
</tr>
<tr>
<td>600万円超</td>
<td>558,000円</td>
</tr>
<!-- /.table --></table>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>

<ul class="list-notice">
<li class="list-notice__item"><small><span class="list-notice__item-mark">＊ </span>総所得金額等から住民税の基礎控除額33万円を差し引いた額。</small></li>
<!-- /.list-notice --></ul>
</div>
</div>
<!-- ▲▲▲ 53万円以上の場合表示 ▲▲▲ -->

<!-- /.toggle__content --></div>
</transition>

<div class="toggle__foot">
<button type="button" class="toggle__foot-button" @click="show02 = !show02"><span class="toggle__foot-button-inner" v-if="show02">計算の詳細を閉じる</span><span class="toggle__foot-button-inner" v-else><span class="toggle__foot-button-inner-open">計算の詳細を開く</span></span></button>
<!-- /.toggle__foot --></div>
<!-- /.toggle --></div>



<div class="toggle toggle--type-03">
<div class="toggle__head">
<h3 class="toggle__head-heading">働けなくなったら</h3>
<p class="toggle__head-sum"><span class="toggle__head-sum-label">傷病手当金　1日あたり</span> <span class="toggle__head-sum-price">{{shoubyoTeateString}}</span><span class="toggle__head-sum-unit">円</span></p>
<!-- /.toggle__head --></div>
<transition
  @enter="showItem"
  @after-enter="printAfterEnter"
  @leave="hideItem"
  @after-leave="printAfterLeave"
  v-bind:css="false"
>
<div class="toggle__content" id="show03" v-show="show03">
<h4 class="toggle__content-heading">傷病手当金<sup v-show="!agencyMode && (!(value3 === '自営業' || value3 === '専業主婦・専業主夫') && !(agencyMode && value4 === '健康保険の被扶養者'))">*1</sup></h4>

<div v-if="value3 === '自営業' || value3 === '専業主婦・専業主夫'">
<p>原則、傷病手当金はございません。</p>
</div>
<div v-else>
<p class="detailed-result detailed-result--type-04">
<span class="detailed-result__formula">
<span class="detailed-result__group detailed-result__group--groupe-01">
<span class="detailed-result__formula-desc">支給開始日以前の12か月の各月の<br>標準報酬月額を平均した額</span>
<span class="detailed-result__formula-value">{{hyoujunHoushuGetugakuHeikinString}}</span>
<span class="detailed-result__formula-unit">円</span>
<span class="detailed-result__formula-operator">÷</span>
<span class="detailed-result__formula-constant">30</span>
<span class="detailed-result__formula-operator">×</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-02">
<span class="detailed-result__formula-constant">2</span>
<span class="detailed-result__formula-operator">÷</span>
<span class="detailed-result__formula-constant">3</span>
<span class="detailed-result__formula-operator">＝</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__formula --></span>

<span class="detailed-result__answer detailed-result__answer--type-02">
<span class="detailed-result__answer-label">1日あたり</span>
<span class="detailed-result__answer-inner">
<span class="detailed-result__answer-value">{{shoubyoTeateString}}</span>
<span class="detailed-result__answer-unit">円</span>
<!-- /.detailed-result__answer-inner --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>

<ul class="list-notice">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>傷病手当金の算出には賞与は含みません。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>公務員等の場合、計算基準が異なる場合があります。</small></li>
<!-- /.list-notice --></ul>

<ul class="list-notice" v-show="!agencyMode && !(agencyMode && value4 === '健康保険の被扶養者')">
<li class="list-notice__item"><small><span class="list-notice__item-mark">＊1 </span>健康保険と厚生年金では標準報酬月額の上限が異なりますが、この試算ツールにおいては厚生年金の標準報酬月額（上限62万円）を活用しているため、現在のご自身の標準報酬月額が62万円を超える方については個別にご相談ください。<br>また、入社1年未満の場合、加入している健康保険等の全加入者の標準報酬月額の平均額が基準額となることもあります。</small></li>
<!-- /.list-notice --></ul>
</div>
<!-- /.toggle__content --></div>
</transition>

<div class="toggle__foot">
<button type="button" class="toggle__foot-button" @click="show03 = !show03"><span class="toggle__foot-button-inner" v-if="show03">計算の詳細を閉じる</span><span class="toggle__foot-button-inner" v-else><span class="toggle__foot-button-inner-open">計算の詳細を開く</span></span></button>
<!-- /.toggle__foot --></div>
<!-- /.toggle --></div>



<div class="toggle toggle--type-04">
<div class="toggle__head">
<h3 class="toggle__head-heading">お亡くなりになったら</h3>
<p class="toggle__head-sum"><span class="toggle__head-sum-label">遺族年金　年額</span> <span class="toggle__head-sum-price">{{izokuNenkinTotalString}}</span><span class="toggle__head-sum-unit">円</span></p>
<!-- /.toggle__head --></div>
<transition
  @enter="showItem"
  @after-enter="printAfterEnter"
  @leave="hideItem"
  @after-leave="printAfterLeave"
  v-bind:css="false"
>
<div class="toggle__content" id="show04" v-show="show04">
<h4 class="toggle__content-heading">遺族厚生年金</h4>

<div class="box-underline">
<p class="detailed-result detailed-result--type-05">
<span class="detailed-result__formula">
<span class="detailed-result__group detailed-result__group--groupe-01" v-show="value3 === '会社員・公務員' && !(value2 === '女性' && value7 === 0)">
<span class="detailed-result__formula-desc"><span class="detailed-result__formula-desc-inner">入社から現在までの<br>平均年収<sup>*1</sup></span></span>
<span class="detailed-result__formula-value">{{heikinNenshuString}}</span>
<span class="detailed-result__formula-unit">円</span>
<span class="detailed-result__formula-operator">×</span>
<span class="detailed-result__formula-constant">5.481</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-02" v-show="value3 === '会社員・公務員' && !(value2 === '女性' && value7 === 0)">
<span class="detailed-result__formula-operator">÷</span>
<span class="detailed-result__formula-constant">1,000</span>
<span class="detailed-result__formula-operator">×</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-03" v-show="value3 === '会社員・公務員' && !(value2 === '女性' && value7 === 0)">
<span class="detailed-result__formula-desc">現在までの勤務年数<br>（最低25年）</span>
<span class="detailed-result__formula-value">{{kinzokuNensu}}</span>
<span class="detailed-result__formula-unit">年</span>
<span class="detailed-result__formula-operator">×</span>
<span class="detailed-result__formula-constant">75％</span>
<!-- /.detailed-result__group --></span>

<span class="detailed-result__group detailed-result__group--groupe-04" v-show="value2 === '男性' && value3 === '会社員・公務員' && value5 === 1 && 40 <= value6 && value6 <= 64 && value7 === 0">
<span class="detailed-result__formula-operator">＋</span>
<span class="detailed-result__formula-desc">中高齢寡婦加算</span>
<span class="detailed-result__formula-constant">584,500円</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__formula --></span>

<span class="detailed-result__answer">
<span class="detailed-result__group">
<span class="detailed-result__formula-operator">＝</span>
<span class="detailed-result__formula-value"><span class="detailed-result__formula-value-index">③ </span>{{izokuKouseiNenkinTotalString}}</span>
<span class="detailed-result__formula-unit">円</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>

<ul class="list-notice">
<li class="list-notice__item" v-show="50 <= value1"><small><span class="list-notice__item-mark">※ </span>遺族厚生年金の概算額は、現在の収入が60歳まで継続したものとして試算しておりますので、実際の金額は少なくなる可能性があります。</small></li>
<li class="list-notice__item" v-show="value3 === '会社員・公務員' && !(value2 === '女性' && value7 === 0)"><small><span class="list-notice__item-mark">＊1 </span>ねんきん定期便の「老齢厚生年金の見込額」を基に算出しておりますので、実際の平均年収とは異なる可能性があります。</small></li>
<!-- /.list-notice --></ul>
<!-- /.box-underline --></div>

<h4 class="toggle__content-heading">遺族基礎年金</h4>

<div class="box-underline">
<p class="detailed-result detailed-result--type-06">
<span class="detailed-result__formula">
<!-- /.detailed-result__formula --></span>
<span class="detailed-result__answer">
<span class="detailed-result__group">
<span class="detailed-result__formula-value"><span class="detailed-result__formula-value-index">④ </span>{{izokuKisoNenkinTotalString}}</span>
<span class="detailed-result__formula-unit">円</span>
<!-- /.detailed-result__group --></span>
<!-- /.detailed-result__answer --></span>
<!-- /.detailed-result --></p>

<ul class="list-notice">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>18歳到達年度末日までの子どもの人数によって金額が異なります。なお、6人以上の場合は5人として試算しております。</small></li>
<!-- /.list-notice --></ul>
<!-- /.box-underline --></div>

<div class="toggle__content-total toggle__content-total--type-2">
<p><span class="toggle__content-total-label">遺族年金（③＋④）年額</span><span class="toggle__content-total-price"><em class="toggle__content-total-price-num">{{izokuNenkinTotalString}}</em><span class="toggle__content-total-price-unit">円</span></span></p>
<!-- /.toggle__content-total --></div>
<!-- /.toggle__content --></div>
</transition>

<div class="toggle__foot">
<button type="button" class="toggle__foot-button" @click="show04 = !show04"><span class="toggle__foot-button-inner" v-if="show04">計算の詳細を閉じる</span><span class="toggle__foot-button-inner" v-else><span class="toggle__foot-button-inner-open">計算の詳細を開く</span></span></button>
<!-- /.toggle__foot --></div>
<!-- /.toggle --></div>

<ul class="list-notice">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>この試算ツールは60歳未満の方が対象です。</small></li>
<li class="list-notice__item" v-if="!agencyMode"><small><span class="list-notice__item-mark">※ </span>この試算ツールの結果は、お客さまのねんきん定期便の情報もしくはねんきん定期便をお持ちでない場合にヒアリングする情報、および年収等が正しく入力されることを前提として算出しています。よって、実際の受給額と乖離する可能性があります。</small></li>
<li class="list-notice__item" v-else><small><span class="list-notice__item-mark">※ </span>この試算ツールの結果は、お客さまのねんきん定期便の情報もしくはねんきん定期便をお持ちでない場合にヒアリングする情報、および年収等が正しく入力されることを前提として算出しています。よって、実際の受給額と乖離する可能性があります。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>いずれの金額も一定の条件のもとに算出した概算値のため、実際の受給額を保証するものではありません。また、記載内容は2018年4月現在の健康保険と公的年金制度に基づくものであり、将来変更される可能性があります。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>各種制度を受けるには受給資格などの条件があります。最新かつ正確な情報は日本年金機構等でご確認ください。</small></li>
<!-- /.list-notice --></ul>

<p>監修：株式会社セールス手帖社保険FPS研究所</p>

<div class="button-back">
<router-link tag="button" type="button" class="button-back__button" to="step2agency" v-if="agencyMode && validateStep2AgencySkipStep3">
<span class="button-back__button-inner">STEP2に戻る</span>
<!-- /.button-back__button --></router-link>
<router-link tag="button" type="button" class="button-back__button" to="step2" v-else-if="validateStep2SkipStep3">
<span class="button-back__button-inner">STEP2に戻る</span>
<!-- /.button-back__button --></router-link>
<router-link tag="button" type="button" class="button-back__button" to="step2agency" v-else-if="agencyMode && step2HelpMode && value3 === '専業主婦・専業主夫' && value4 === '健康保険の被扶養者'">
<span class="button-back__button-inner">STEP2に戻る</span>
<!-- /.button-back__button --></router-link>
<router-link tag="button" type="button" class="button-back__button" to="step2" v-else-if="step2HelpMode && value3 === '専業主婦・専業主夫' && value4 === '健康保険の被扶養者'">
<span class="button-back__button-inner">STEP2に戻る</span>
<!-- /.button-back__button --></router-link>
<router-link tag="button" type="button" class="button-back__button" to="step3" v-else>
<span class="button-back__button-inner">STEP3に戻る</span>
<!-- /.button-back__button --></router-link>
<router-link tag="button" type="button" class="button-back__button" to="step1" v-if="agencyMode" @click.native="resetAllValueByEvent">
<span class="button-back__button-inner">リセットしてSTEP1に戻る</span>
<!-- /.button-back__button --></router-link>
<div class="box-social" v-show="!agencyMode">
<p class="box-social__text">この試算ツールをおすすめする！</p>
<ul class="list-social">
<li class="list-social__item">
<a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-url="https://www.orixlife.co.jp/guide/nenkinteikibin2018/sim/" data-text="ねんきん定期便でわかる！公的保障試算ツール｜オリックス生命保険株式会社" data-show-count="false" data-size="large">ツイート</a>
<!-- /.list-social__item --></li>
<li class="list-social__item">
<div class="fb-share-button" data-href="https://www.orixlife.co.jp/guide/nenkinteikibin2018/sim/" data-layout="button" data-size="large" data-mobile-iframe="false">
<a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.orixlife.co.jp%2Fguide%2Fnenkinteikibin2018%2Fsim%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">シェア</a>
</div>
<!-- /.list-social__item --></li>
<!-- /.list-social --></ul>
<!-- /.box-social --></div>
<!-- /.button-back --></div>
<!-- /.step__main --></div>

<div class="step__foot" :class="agencyMode ? 'step__foot--agency-mode' : ''">
<!-- ▼▼▼ 一般の方の場合表示 ▼▼▼ -->
<p class="text-lead" v-show="!agencyMode"><span class="text-big">試算結果について会ってご相談</span>されたい方はこちら</p>

<div class="button-contact" v-show="!agencyMode">
<a href="/guide/agent.html?&amp;oKL=25ssc21" class="button-contact__button" @click="meetAndConsultByEvent">
<span class="button-contact__button-inner">保険相談窓口</span>
<!-- /.button-contact__button --></a>
<!-- /.button-contact --></div>

<div class="box-security" v-show="!agencyMode">
<div class="box-security__inner">
<p class="text-lead">ご自身で保障をご検討されたい方はこちら</p>

<div class="button-security">
<a :href="smartDevice ? '/sp/sim?index=1&amp;p=3F&amp;p=4N&amp;p=4C' : '/sim?index=1&amp;p=3F&amp;p=4N&amp;p=4C'" class="button-security__button button-security__button--simulation" @click="simulateInsuranceFeeByEvent">
<span class="button-security__button-label">カンタン1分</span>
<span class="button-security__button-inner">保険料<br>シミュレーション</span>
<!-- /.button-security__button --></a>

<a href="/request-doc?oKL=25ssc11" class="button-security__button button-security__button--document" @click="requestDocumentByEvent">
<span class="button-security__button-label">詳しい資料をお届け</span>
<span class="button-security__button-inner">資料請求</span>
<!-- /.button-security__button --></a>
<!-- /.button-security --></div>
<!-- /.box-security__inner --></div>
<!-- /.box-security --></div>
<!-- ▲▲▲ 一般の方の場合表示 ▲▲▲ -->

<!-- ▼▼▼ 代理店の場合表示 ▼▼▼ -->
<div class="column column--col-2" v-show="agencyMode">
<div class="column__inner">
<div class="column__col">
<div class="button-submit">
<button type="button" class="button-submit__button" @click="printDetailByEvent">
<span class="button-submit__button-inner">全てを印刷する</span>
<!-- /.button-submit__button --></button>
<!-- /.button-submit --></div>
<!-- /.column__col --></div>

<div class="column__col">
<div class="button-submit">
<button type="button" class="button-submit__button" @click="printByEvent">
<span class="button-submit__button-inner">試算結果のみを印刷する</span>
<!-- /.button-submit__button --></button>
<!-- /.button-submit --></div>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>
<!-- ▲▲▲ 代理店の場合表示 ▲▲▲ -->
<!-- /.step__foot --></div>
<!-- /.step --></div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Utils from '../assets/js/Utils';
    import Velocity from 'velocity-animate';

    export default {
        computed: {
            ...mapGetters([
                'agencyCode',
                'agentCode',
                'agencyMode',
                'value1',
                'value2',
                'value3',
                'value4',
                'value5',
                'value6',
                'value7',
                'value8',
                'value9',
                'value10_1',
                'value10_2',
                'value10_3',
                'value11_1',
                'value11_2',
                'value12_1',
                'value12_2',
                'value12_3',
                'value12_4',
                'value12_5',
                'value12_6',
                'value12_7',
                'value12_8',
                'value12_9',
                'value12_10',
                'value12_11',
                'value12_12',
                'value12_13',
                'value12_14',
                'value12_15',
                'value12_16',
                'value12_17',
                'value12_18',
                'value12_19',
                'value12_20',
                'value12_21',
                'value12_22',
                'value12_23',
                'value12_24',
                'value13',
                'value14',
                'value15',
                'validateStep2SkipStep3',
                'validateStep2AgencySkipStep3',
                'value12Inputed',
                'roureiKouseiNenkinString',
                'heikinMikomiNenshuString',
                'yoteiKinzokuNensu',
                'roureiKouseiNenkinTotalString',
                'roureiKisoNenkinString',
                'roureiNenkinTotalString',
                'kougakuRyouyouValue',
                'kougakuRyouyouValueString',
                'hyoujunHoushuGetugakuHeikinString',
                'shoubyoTeateString',
                'heikinNenshuString',
                'kinzokuNensu',
                'koremadenoKanyuuJissekiNiOujitaNenkinGakuString',
                'genzaiKara60SaiMadenoNensu',
                'izokuKouseiNenkinTotalString',
                'izokuKisoNenkinTotalString',
                'izokuNenkinTotalString',
                'step2HelpMode'
            ])
        },
        data() {
            return {
                show01: false,
                show01_show: false, // id="show01" の表示状態
                show02: false,
                show02_show: false, // id="show02" の表示状態
                show03: false,
                show03_show: false, // id="show03" の表示状態
                show04: false,
                show04_show: false, // id="show04" の表示状態
                print: false,
                smartDevice: false
            };
        },
        methods: {
            ...mapActions([
                'changeValue1',
                'changeValue1Text',
                'changeValue2',
                'changeValue2Text',
                'changeValue3',
                'changeValue3Text',
                'changeValue4',
                'changeValue4Text',
                'changeValue5',
                'changeValue5Text',
                'changeValue6',
                'changeValue6Text',
                'changeValue7',
                'changeValue7Text',
                'changeValue8',
                'changeValue8Text',
                'changeValue9',
                'changeValue9Text',
                'changeValue10_1',
                'changeValue10_1Text',
                'changeValue10_2',
                'changeValue10_2Text',
                'changeValue10_3',
                'changeValue10_3Text',
                'changeValue11_1',
                'changeValue11_1Text',
                'changeValue11_2',
                'changeValue11_2Text',
                'changeValue12_1',
                'changeValue12_1Text',
                'changeValue12_2',
                'changeValue12_3',
                'changeValue12_4',
                'changeValue12_5',
                'changeValue12_6',
                'changeValue12_7',
                'changeValue12_8',
                'changeValue12_9',
                'changeValue12_10',
                'changeValue12_11',
                'changeValue12_12',
                'changeValue12_13',
                'changeValue12_13Text',
                'changeValue12_14',
                'changeValue12_15',
                'changeValue12_16',
                'changeValue12_17',
                'changeValue12_18',
                'changeValue12_19',
                'changeValue12_20',
                'changeValue12_21',
                'changeValue12_22',
                'changeValue12_23',
                'changeValue12_24',
                'changeValue13',
                'changeValue13Text',
                'changeValue14',
                'changeValue14Text',
                'changeValue15',
                'changeValue15Text'
            ]),
            // 「会って相談」ボタン押下時イベントリスナー
            meetAndConsultByEvent() {
                const s = window.s;

                if (s) {
                    s.tl(window, 'o', '公的保障試算ツール 会って相談');
                }
            },
            // 「保険料シミュレーション」ボタン押下時イベントリスナー
            simulateInsuranceFeeByEvent() {
                const s = window.s;

                if (s) {
                    s.tl(window, 'o', '公的保障試算ツール 保険料シミュレーション');
                }
            },
            // 「資料請求」ボタン押下時イベントリスナー
            requestDocumentByEvent() {
                const s = window.s;

                if (s) {
                    s.tl(window, 'o', '公的保障試算ツール 資料請求');
                }
            },
            showItem(el, done) {
                const id = el.getAttribute('id') || '';
                const $data = this.$data;

                Velocity(el, 'slideDown', { // eslint-disable-line
                    duration: 300,
                    complete(...args) {
                        $data[id + '_show'] = true;

                        return done(...args);
                    }
                });
            },
            hideItem(el, done) {
                const id = el.getAttribute('id') || '';
                const $data = this.$data;

                Velocity(el, 'slideUp', { // eslint-disable-line
                    duration: 300,
                    complete(...args) {
                        $data[id + '_show'] = false;

                        return done(...args);
                    }
                });
            },
            printAfterEnter() {
                if (
                    this.$data.show01_show === true &&
                    this.$data.show02_show === true &&
                    this.$data.show03_show === true &&
                    this.$data.show04_show === true &&
                    this.$data.print === true
                ) {
                    this.$data.print = false;
                    window.print();
                }
            },
            printAfterLeave() {
                if (
                    this.$data.show01_show === false &&
                    this.$data.show02_show === false &&
                    this.$data.show03_show === false &&
                    this.$data.show04_show === false &&
                    this.$data.print === true
                ) {
                    this.$data.print = false;
                    window.print();
                }
            },
            // 「金額のみを印刷する」ボタン押下時イベントリスナー
            printByEvent(event) {
                const s = window.s;

                event.preventDefault();

                if (s) {
                    s.tl(window, 'o', '公的保障試算ツール 金額のみを印刷する');
                }

                if (
                    this.$data.show01_show === false &&
                    this.$data.show02_show === false &&
                    this.$data.show03_show === false &&
                    this.$data.show04_show === false
                ) {
                    // 最初からすべて閉じている
                    this.$data.print = false;
                    window.print();
                } else {
                    // 1つでも開いている
                    this.$data.show01 = false;
                    this.$data.show02 = false;
                    this.$data.show03 = false;
                    this.$data.show04 = false;

                    this.$data.print = true;
                }
            },
            // 「詳細情報を印刷する」ボタン押下時イベントリスナー
            printDetailByEvent(event) {
                const s = window.s;

                event.preventDefault();

                if (s) {
                    s.tl(window, 'o', '公的保障試算ツール 詳細情報を印刷する');
                }

                if (
                    this.$data.show01_show === true &&
                    this.$data.show02_show === true &&
                    this.$data.show03_show === true &&
                    this.$data.show04_show === true
                ) {
                    // 最初からすべて開いている
                    this.$data.print = false;
                    window.print();
                } else {
                    // 1つでも閉じている
                    this.$data.show01 = true;
                    this.$data.show02 = true;
                    this.$data.show03 = true;
                    this.$data.show04 = true;

                    this.$data.print = true;
                }
            },
            resetAllValue() {
                this.changeValue1('');
                this.changeValue1Text('');
                this.changeValue2('');
                this.changeValue2Text('');
                this.changeValue3('');
                this.changeValue3Text('');
                this.changeValue4('');
                this.changeValue4Text('');
                this.changeValue5('');
                this.changeValue5Text('');
                this.changeValue6('');
                this.changeValue6Text('');
                this.changeValue7('');
                this.changeValue7Text('');
                this.changeValue8('');
                this.changeValue8Text('');
                this.changeValue9('');
                this.changeValue9Text('');
                this.changeValue10_1('');
                this.changeValue10_1Text('');
                this.changeValue10_2('');
                this.changeValue10_2Text('');
                this.changeValue10_3('');
                this.changeValue10_3Text('');
                this.changeValue11_1('');
                this.changeValue11_1Text('');
                this.changeValue11_2('');
                this.changeValue11_2Text('');
                this.changeValue12_1('');
                this.changeValue12_1Text('');
                this.changeValue12_2('');
                this.changeValue12_3('');
                this.changeValue12_4('');
                this.changeValue12_5('');
                this.changeValue12_6('');
                this.changeValue12_7('');
                this.changeValue12_8('');
                this.changeValue12_9('');
                this.changeValue12_10('');
                this.changeValue12_11('');
                this.changeValue12_12('');
                this.changeValue12_13('');
                this.changeValue12_13Text('');
                this.changeValue12_14('');
                this.changeValue12_15('');
                this.changeValue12_16('');
                this.changeValue12_17('');
                this.changeValue12_18('');
                this.changeValue12_19('');
                this.changeValue12_20('');
                this.changeValue12_21('');
                this.changeValue12_22('');
                this.changeValue12_23('');
                this.changeValue12_24('');
                this.changeValue13('');
                this.changeValue13Text('');
                this.changeValue14('');
                this.changeValue14Text('');
                this.changeValue15('');
                this.changeValue15Text('');
            },
            // 「リセットしてSTEP1に戻る」ボタン押下時イベントリスナー
            resetAllValueByEvent(event) {
                event.preventDefault();

                this.resetAllValue();
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const s = window.s;

                if (s) {
                    if (from.name !== null && to.name === 'Step4') {
                        // 他 STEP からの遷移時
                        const results = [
                            vm.roureiNenkinTotalString,
                            vm.kougakuRyouyouValueString,
                            vm.shoubyoTeateString,
                            vm.izokuNenkinTotalString
                        ];
                        const joinedResults = results.join('|');
                        let agencyVariableString;
                        let sCode;

                        if (vm.agencyMode) {
                            agencyVariableString = vm.agencyCode + '|' + vm.agentCode;
                        } else {
                            agencyVariableString = '|';
                        }

                        s.pageName = '【RWD】公的保障試算ツール(結果)';
                        s.prop11 = agencyVariableString;
                        s.eVar11 = agencyVariableString;
                        s.prop12 = '';
                        s.eVar12 = '';
                        s.prop13 = '';
                        s.eVar13 = '';
                        s.prop14 = '';
                        s.eVar14 = '';
                        s.prop15 = joinedResults;
                        s.eVar15 = joinedResults;
                        s.events = 'event4';

                        sCode = s.t();

                        if (sCode) {
                            document.write(sCode);
                        }
                    }
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            const sendTrackingCode = () => {
                const s = window.s;

                if (s) {
                    if (from.name === 'Step4' && to.name === 'Step3') {
                        s.tl(window, 'o', '公的保障試算ツール STEP3に戻る');
                    } else if (from.name === 'Step4' && (to.name === 'Step2' || to.name === 'Step2Agency')) {
                        s.tl(window, 'o', '公的保障試算ツール STEP2に戻る');
                    } else if (from.name === 'Step4' && to.name === 'Step1') {
                        s.tl(window, 'o', '公的保障試算ツール リセットしてSTEP1に戻る');
                    }
                }
            };

            if (from.name === 'Step4' && to.name === 'Step3') {
                sendTrackingCode();
                next();
            } else if (!this.agencyMode && from.name === 'Step4' && to.name === 'Step2') {
                sendTrackingCode();
                next();
            } else if (this.agencyMode && from.name === 'Step4' && to.name === 'Step2Agency') {
                sendTrackingCode();
                next();
            } else if (from.name === 'Step4' && to.name === 'Step1') {
                sendTrackingCode();
                next();
            } else {
                next(false);
            }
        },
        mounted() {
            // SNSボタンの初期化
            const twttr = window.twttr;
            const FB = window.FB;

            if (twttr) {
                twttr.widgets.load();
            }

            if (FB) {
                FB.XFBML.parse();
            }

            // スマートデバイスであるか否かの判定
            this.smartDevice = Utils.checkSmartDevice();
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Step4.vue